<template>
  <div id="myElement"
       style="position: absolute; width: 100%; height: 100%; top: 0; background: #f5f5f5">
    <headers></headers>
    <!-- 移动端头部 -->
    <div class="phoneHead">
      <div class="back"
           @click="back">
        <img src="../../assets/img/phoneBack.png"
             alt="" />
             <div @click="goStudy" class="goStudy">返回学习中心</div>
      </div>
      <div class="texs">我的章节</div>
      <div class="back"></div>
    </div>
    <div style="display: flex; justify-content: center; background: #f5f5f5">
      <div class="banner">
        <div class="title"><span style="cursor: pointer;" @click="goClass">我的在学班级</span> > <span  style="cursor: pointer;"  @click="goCourse">{{ className }}</span> > {{ name }}的章节列表</div>

        <div class="courseBox">
          <el-table :data="courseWareList"
                    style="width: 100%"
                    header-cell-class-name="tableStyle"
                    cell-class-name="cellStyle">
            <el-table-column prop="cwName"
                             label="章节名称"
                             width="180"> </el-table-column>
            <el-table-column prop="jinDu"
                             label="学习进度"
                             width="180">
              <template slot-scope="scope"> {{ scope.row.jinDu }}% </template>
            </el-table-column>
            <el-table-column prop="creditnum"
                             label="学时"> </el-table-column>
            <el-table-column label="学习状态">
              <template slot-scope="scope">
                {{ scope.row.courseWares == '02' ? '已完成' : '未完成' }}
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <div class="btnSc"
                     @click="goVideo(scope.row)">立即播放</div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="pagination"
             style="display: flex; justify-content: center">
          <pagination background
                      v-show="courseWareData.total > 0"
                      :total="courseWareData.total"
                      :page.sync="query.pageNum"
                      :limit.sync="query.pageSize"
                      @pagination="getList">
          </pagination>
        </div>
      </div>

      <div class="phoneBanner">
        <div class="chapter"
             v-for="item in courseWareList"
             :key="item.id">
          <div class="titleText">
            {{ item.cwName }}
          </div>

          <div class="botBox">
            <div class="xue">总学时：{{ item.creditnum }}学时</div>

            <div class="xueBtn"
                 @click="goVideo(item)">播放</div>
          </div>

          <div class="rightStatus">{{ item.jinDu }}%</div>
        </div>

        <div style="text-align: center"
             class="more"
             @click="more">
          {{ text }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
// Import Swiper Vue.js components
// Import Swiper styles
import headers from '@/views/component/head.vue';
import { toMyCourseWareList,getUrl } from '../../api/index';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    headers
  },
  data() {
    // 这里存放数据
    return {
      name: '',
      className: '',
      courseId: '',
      classId: '',
      courseWareList: [],
      courseWareData: {
        total: 0
      },
      tableData: [],
      query: {
        pageSize: 5,
        pageNum: 1
      },
      text: '' //提示语
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    //跳到班级
    goClass() {
      this.$router.push({
        path:'/',
      
      })
    },
    //跳到课程
    goCourse() {
      this.$router.push({
        path:'/questions',
        query:{
          id:this.classId
        }
      })
    },
    goStudy() {
      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      getUrl().then(res => {
        console.log(res.data.data);
        if (isMobile) {
          window.location.replace(res.data.data.mobileCenterUrl + '?token=' + localStorage.getItem('token'));
        } else {
          window.location.replace(res.data.data.pcCenterUrl + '?token=' + localStorage.getItem('token'));
        }
      });
    },
    back() {
      this.$router.back();
    },
    getList() {
      this.query.courseId = this.courseId;
      this.query.classId = this.classId;
      console.log(this.query);
      toMyCourseWareList(this.query).then(res => {
        if (res.data.code == '200') {
          this.courseWareList = res.data.data.rows;
          this.courseWareData = res.data.data;
          this.className = res.data.data.className
          this.classId = res.data.data.classId
          this.courseId = res.data.data.courseId
          this.name = res.data.data.courseName
          if (this.courseWareData.total <= this.query.pageSize * this.query.pageNum) {
            this.text = '';
          } else {
            this.text = '点击加载更多...';
          }
          console.log(res.data.data);
        } else {
          this.$message('请求错误,请稍后再试！');
        }
      });
    },
    more() {
      this.query.pageNum = this.query.pageNum + 1;
      toMyCourseWareList(this.query).then(res => {
        if (res.data.code == '200') {
          
          this.courseWareList.push(...res.data.data.rows);
          if (this.courseWareData.total <= this.query.pageSize * this.query.pageNum) {
            this.text = '';
          } else {
            this.text = '点击加载更多...';
          }
          console.log(res.data.data);
        } else {
          this.$message('请求错误,请稍后再试！');
        }
      });
    },
    goVideo(row) {
      this.$router.push({ path: '/fraction', query: { classId: this.classId, courseId: row.courseId, courseWareId: row.courseWareId } });
    }
  },
  created() {
    this.courseId = this.$route.query.id;
    this.classId = this.$route.query.classId;
    this.getList();
  },
  destroyed() {},
  beforeDestroy() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
@media (max-width: 768px) {
  .more {
    font-size: 16px;
  }
  .goStudy {
    position: absolute;
    z-index: 99;
    color: #fff;
    right:15px;
    top: 7px;
    width: 100px;
    height: 32px;
    cursor: pointer;
    font-size: 13px;
    background: #438ce7;
    text-align: center;
    line-height: 32px;
    border-radius: 32px;
  }
  .phoneHead {
    width: 100%;
    height: 46px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #ffffff;
    font-family: Medium;
    .back {
      width: 50px;
      img {
        width: 25px;
        height: 25px;
      }
    }
    .texs {
      font-size: 17px;
    }
  }
  /deep/ .xgplayer-fullscreen .xgplayer-fullscreen-img {
    display: none !important;
  }
  .banner {
    display: none;
  }

  .phoneBanner {
    width: 100%;
    padding: 15px;
    background: #ffffff;
    padding-bottom: 160px;
    .chapter {
      width: 100%;
      background: #f5f5f9;
      padding: 15px;
      position: relative;
      border-radius: 6px;
      margin-bottom: 10px;
      .rightStatus {
        position: absolute;
        right: 0;
        top: 0;
        width: 65px;
        height: 24px;
        background: rgba(255, 128, 0, 0.15);
        border-radius: 0px 6px 0px 26px;
        text-align: center;
        line-height: 24px;
        font-size: 13px;
        color: #ff8000;
        font-family: Medium;
      }
      .titleText {
        margin-top: 24px;
        font-size: 16px;
        color: #333333;
        font-family: Medium;
      }
      .botBox {
        margin-top: 11px;
        display: flex;
        justify-content: space-between;
        .xue {
          margin-top: 6px;
          font-family: Regular;
          color: #666666;
          font-size: 14px;
        }
        .xueBtn {
          width: 75px;
          height: 32px;
          border: 1px solid #2878ff;
          opacity: 1;
          border-radius: 18px;
          color: #2878ff;
          font-size: 14px;
          text-align: center;
          line-height: 32px;
        }
      }
    }
  }
}

@media (min-width: 768px) {
  .phoneHead {
    display: none;
  }
  .phoneBanner {
    display: none;
  }
  .banner {
    width: 1200px;
    padding-top: 28px;
    font-family: Regular;
    .title {
      font-size: 18px;
      color: #333333;
      font-family: Bold;
    }
    .courseBox {
      margin-top: 12px;
      width: 1200px;
      background: #ffffff;
      padding: 8px 20px 20px 20px;
      .btnSc {
        width: 80px;
        height: 30px;
        border: 1px solid #2878ff;
        opacity: 1;
        border-radius: 15px;
        cursor: pointer;
        text-align: center;
        line-height: 30px;
        color: #2878ff;
        margin: 0 auto;
      }
      /deep/.tableStyle {
        background-color: #f7f7f7 !important;
        color: #666666;
        font-size: 14px;
        text-align: center;
        height: 44px;
      }
      /deep/.cellStyle {
        text-align: center;
        font-size: 14px;
        height: 60px;
        font-weight: 400;
        color: #333333;
        overflow: hidden;
      }
      .listBox {
        margin-top: 12px;
        width: 100%;
        height: 109px;
        display: flex;
        border-bottom: 1px solid #eee;
        .leftBox {
          display: flex;
          .imgBox {
            width: 120px;
            height: 97px;
          }
          .left_2 {
            margin-left: 12px;
            .text_1 {
              margin-top: 8px;
              font-family: Bold;
              font-size: 18px;
              color: #333333;
              width: 275px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
            .text_2 {
              margin-top: 8px;
              width: 100px;
              height: 26px;
              text-align: center;
              font-family: Medium;
              line-height: 26px;
              background: rgba(40, 120, 255, 0.1);
              color: #2878ff;
              border-radius: 2px;
              font-size: 12px;
            }
            .text_3 {
              margin-top: 12px;
              font-size: 14px;
              font-family: Medium;
              font-weight: 500;
              color: #666666;
            }
            .text_4 {
              margin-top: 5px;
              font-size: 14px;
              font-family: Medium;
              font-weight: 500;
              color: #666666;
            }
          }
        }

        .centerBox {
          width: 200px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          margin-left: 70px;
          margin-bottom: 15px;
          .vis1 {
            margin-top: 8px;
            font-family: Medium;
            color: #666666;
            text-align: center;
            font-size: 14px;
          }
        }

        .rightBox {
          display: flex;
          flex-direction: column;
          justify-content: center;
          margin-left: 377px;
          div {
            width: 100px;
            height: 32px;
            border: 1px solid #2878ff;
            border-radius: 19px;
            background: #ffffff;
            border: 1px solid #2878ff;
            opacity: 1;
            cursor: pointer;
            color: #2878ff;
            font-size: 14px;
            text-align: center;
            line-height: 32px;
            font-family: Regular;
          }
        }
      }
    }
    .pagination {
      padding: 30px 0 100px 0;
    }
  }
}
</style>
